import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ApiError } from 'app/core';
import { PortfolioApi } from 'app/domains/core/settings/portfolio/apis/portfolio.api';
import { EnumRelevancia } from 'app/domains/core/settings/portfolio/enums/relevancia.enum';
import { IClientePortfolio } from 'app/domains/core/settings/portfolio/interfaces/cliente-portfolio-response.interface';
import { ISelectOption } from '../select/models/select-option.interface';
import { ToastService } from '../toast/services/toast.service';
import {
  IPortfolioCategoriaTreeCategoria,
  IPortfolioTree
} from './portfolio-categoria-tree-table.interface';

@Component({
  selector: 'sgt-portfolio-categoria-tree-table',
  templateUrl: './portfolio-categoria-tree-table.component.html',
  styleUrls: ['./portfolio-categoria-tree-table.component.scss']
})
export class PortfolioCategoriaTreeTableComponent implements OnInit {
  @Input() selectedPortfolios: IClientePortfolio[] = [];
  @Input() disabled = false;

  @Output() portfoliosChange = new EventEmitter<IPortfolioTree[]>();

  portfolios: IPortfolioTree[] = [];

  relevanciaSelectOptions: ISelectOption[] = [
    {
      id: EnumRelevancia.A,
      label: 'A',
      isSelected: false
    },
    {
      id: EnumRelevancia.B,
      label: 'B',
      isSelected: false
    },
    {
      id: EnumRelevancia.C,
      label: 'C',
      isSelected: false
    }
  ];

  constructor(
    private portfolioApi: PortfolioApi,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.portfolioApi.listPortfolios().subscribe({
      next: (response) => {
        this.portfolios = response.data.map((p) => {
          const selectedPortfolio = this.selectedPortfolios.find(
            (portfolioSelecionado) =>
              portfolioSelecionado.idPortfolio === p.idPortfolio
          );

          return {
            id: selectedPortfolio?.id ?? null,
            idPortfolio: p.idPortfolio,
            idCliente: selectedPortfolio?.idCliente ?? null,
            nomePortfolio: p.nomePortfolio,
            selecionado: !!selectedPortfolio,
            relevancia: selectedPortfolio?.relevancia ?? EnumRelevancia.A,
            collapsed: !(
              selectedPortfolio && selectedPortfolio.categorias?.length
            ),
            categorias: (p.categorias ?? []).map((c) => {
              const selectedCategoria = selectedPortfolio?.categorias?.find(
                (categoriaSelecionada) =>
                  categoriaSelecionada.idCategoria === c.idCategoria
              );

              return {
                id: selectedCategoria?.id ?? null,
                idCategoria: c.idCategoria,
                nomeCategoria: c.nomeCategoria,
                selecionado: !!selectedCategoria,
                relevancia: selectedCategoria?.relevancia ?? EnumRelevancia.A
              };
            })
          };
        });

        this.cdr.markForCheck();
      },
      error: (err: ApiError) => {
        this.toastService.error(err.message, {
          title: err.cause || 'Aconteceu algo inesperado.',
          duration: 5000
        });
      }
    });
  }

  get totalPortfoliosSelecionados(): number {
    return this.portfolios.filter((p) => p.selecionado).length;
  }

  get totalCategoriasSelecionadas(): number {
    return this.portfolios.reduce((acc, p) => acc + p.categorias.filter((c) => c.selecionado).length, 0);
  }

  toggleCollapse(portfolio: IPortfolioTree): void {
    portfolio.collapsed = !portfolio.collapsed;
  }

  togglePortfolio(portfolio: IPortfolioTree): void {
    portfolio.collapsed = false;
    portfolio.selecionado = !portfolio.selecionado;
    if (!portfolio.selecionado) {
      portfolio.relevancia = null;
      portfolio.categorias.forEach((c) => {
        c.selecionado = false;
        c.relevancia = null;
      });
    } else {
      portfolio.relevancia = EnumRelevancia.A;
    }
    this.emitSelecionados();
  }

  toggleCategoria(
    categoria: IPortfolioCategoriaTreeCategoria,
    portfolio: IPortfolioTree
  ): void {
    categoria.selecionado = !categoria.selecionado;
    if (!categoria.selecionado) {
      categoria.relevancia = null;
    } else {
      categoria.relevancia = EnumRelevancia.A;
      portfolio.selecionado = true;
    }

    const semCategoriaSelecionada = !portfolio.categorias.some(
      (c) => c.selecionado
    );
    if (semCategoriaSelecionada) {
      portfolio.collapsed = true;
    }

    this.emitSelecionados();
  }

  emitSelecionados(): void {
    const selecionados = this.portfolios
      .filter((p) => p.selecionado)
      .map((p) => ({
        ...p,
        categorias: p.categorias.filter((c) => c.selecionado)
      }));
    this.portfoliosChange.emit(selecionados);
  }
}
